import ApiProvider from '../../../../core/api/ApiProvider';
import { ActionStatusType } from '../../../../core/types/ActionStatusType';
import { UpdateMessagesType } from '../types/UpdateMessagesType';
import { CancelToken } from 'axios';

const PuzzleChatApi = {
  getAllCases: async <T = any>(cancelToken: CancelToken): Promise<ActionStatusType<T>> => {
    return await ApiProvider.get<ActionStatusType<T>>('PuzzelChat/GetAllCases', cancelToken);
  },
  getChat: async <T = any>(caseNo: string, tenantUid: string): Promise<ActionStatusType<T>> => {
    return await ApiProvider.get<ActionStatusType<T>>(`PuzzelChat/GetChat/${caseNo}`);
  },
  startChatHistory: async <T = any>(
    caseNo: string,
    prdCaseCode: string,
    startTime: string,
    sourceTenantId: string
  ): Promise<ActionStatusType<T>> => {
    return await ApiProvider.post<ActionStatusType<T>>('PuzzelChat/StartChatHistory', {
      selectedCase: caseNo,
      predatorCaseCode: prdCaseCode,
      startTime: startTime,
      sourceTenantId: sourceTenantId,
    });
  },
  updateChatHistory: async <T = any>(
    unik: string[],
    caseGuid: string[],
    message: UpdateMessagesType[],
    sourceTenantId: string
  ): Promise<ActionStatusType<T>> => {
    return await ApiProvider.post<ActionStatusType<T>>('PuzzelChat/UpdateChatHistory', {
      unik: unik,
      caseGuid: caseGuid,
      messages: message,
      sourceTenantId: sourceTenantId,
    });
  },
};

export default PuzzleChatApi;
